import React from 'react'

import './subHeader.css'

const SubHeader = ({title, description}: any) => {
  return (
    <div className='sub-header-wrapper'>
      <h2 className='sub-header-title'>{title}</h2>
      <p className='sub-header-description'>{description}</p>
    </div>
  )
}

export default SubHeader